<template>
  <div class="payments">
    <a-spin :spinning="spinning">
      <breadcrumbs :breadcrumbsData="breadcrumbsData" />
      <div class="content">
        <div class="tabs">
          <a-tabs v-model:activeKey="activeKey" @change="setDataList">
            <a-tab-pane key="seller" tab="Seller" />
            <a-tab-pane key="publisher" tab="Publisher" />
            <a-tab-pane key="admin" tab="Admin" />
            <template #rightExtra>
              <artmisads-button :disabled="dataList.length" @click="setShowModal" type="primary" size="middle">Add New
                Menu</artmisads-button>
            </template>
          </a-tabs>
          <div class="menu-list-wrapper" ref="tableRef">
            <a-spin :spinning="spinning">
              <artmisads-table v-if="dataList.length" :columns="columns" :data-source="dataList" rowKey="id"
                :defaultExpandAllRows="true" :scroll="{ y: tableScrollHeight }">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.name === 'sorting'">
                    <div class="sort-btn">
                      <artmisads-select-button v-if="record.siblingNum > 1 && record.index > 0"
                        @click="() => onSort(record.id, record.preId)" size="small">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-jiantou-shang-cu"></use>
                        </svg>
                      </artmisads-select-button>
                      <artmisads-select-button v-if="record.siblingNum > 1 && record.index < record.siblingNum - 1"
                        @click="() => onSort(record.id, record.nextId)" size="small">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-jiantou-xia-cu"></use>
                        </svg>
                      </artmisads-select-button>
                    </div>
                  </template>
                  <template v-if="column.name === 'actions'">
                    <div class="actions-btn">
                      <artmisads-select-button @click="() => setInfoData(record)"
                        size="small">Edit</artmisads-select-button>
                      <artmisads-select-button v-if="record.level !== 3" @click="() => addSubMenu(record)"
                        size="small">Add SubMenu</artmisads-select-button>
                      <a-popconfirm title="Are you sure delete this menu?" ok-text="Confirm" cancel-text="Cancel"
                        @confirm="() => deleteMenus(record.id)" :getPopupContainer="() => $refs.tableRef"
                        :overlayStyle="{ width: '200px' }">
                        <artmisads-select-button size="small">Delete</artmisads-select-button>
                      </a-popconfirm>
                    </div>
                  </template>
                  <template v-if="column.name === 'status'">
                    <a-switch :checked="!record.hidden" @change="(status) => changeMenusStatus(status, record.id)" />
                  </template>
                </template>
              </artmisads-table>
            </a-spin>
            <editModal :setShowModal="setShowModal" :menuInfo="menuInfo" :addMenus="addMenus" :changeMenu="changeMenu"
              :userType="activeKey" v-if="showEditModal" />
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import editModal from './editModal.vue';
import breadcrumbs from "../breadcrumbs.vue";
import { menuApi } from "@/server/operator/menuApi";
import { useTableScrollHeight } from "@/utils/useTableScrollHeight";

const dataList = ref([]);
const menuInfo = ref({});
const adminList = ref([]);
const sellerList = ref([]);
const spinning = ref(false);
const publisherList = ref([]);
const activeKey = ref('seller');
const showEditModal = ref(false);
const columns = [
  {
    title: 'Menu Name',
    dataIndex: 'name',
    key: 'name',
    width: '25%',
  },
  {
    title: 'Address',
    dataIndex: 'path',
    width: '15%',
  },
  {
    title: 'Status',
    dataIndex: 'hidden',
    width: '10%',
    name: 'status'
  },
  {
    title: 'Sorting',
    dataIndex: 'id',
    width: '15%',
    name: 'sorting'
  },

  {
    title: 'Actions',
    dataIndex: 'id',
    width: '35%',
    name: 'actions'
  },
];

const setSpinning = status => {
  spinning.value = status;
}

const breadcrumbsData = {
  title: "Menu",
  links: [
    {
      name: "Home",
      path: "/operator/users",
    },
    {
      name: "Menu",
      path: "/operator/menu",
    }
  ],
};

const handleData = data => {
  let newData = { ...data };
  newData.children = newData.children?.map((item, itemIndex) => {
    item.siblingNum = newData.children?.length;
    item.index = itemIndex;
    item.preId = newData.children[itemIndex - 1]?.id;
    item.nextId = newData.children[itemIndex + 1]?.id;
    item.children = item.children?.map((j, jIndex) => {
      j.index = jIndex;
      j.preId = item.children[jIndex - 1]?.id;
      j.nextId = item.children[jIndex + 1]?.id;
      j.siblingNum = item.children?.length;
      j.children = j.children?.map((k, kIndex) => {
        k.index = kIndex;
        k.siblingNum = j.children.length;
        k.preId = j.children[kIndex - 1]?.id;
        k.nextId = j.children[kIndex + 1]?.id;
        return k;
      });
      return j
    })
    return item;
  })
  return newData;
}

const getMenus = async () => {
  spinning.value = true;
  const res = await menuApi.getMenus();
  const adminRes = await menuApi.getMenus({ userType: 'admin' });
  if (res) {
    let sellerData = res.find(i => i.userType === 'seller');
    let publisherData = res.find(i => i.userType === 'publisher');
    let adminData = adminRes.find(i => i.userType === 'admin');

    if (sellerData) {
      sellerData = handleData(sellerData);
      sellerList.value = [sellerData];
    } else {
      sellerList.value = [];
    }

    if (publisherData) {
      publisherData = handleData(publisherData);
      publisherList.value = [publisherData];
    } else {
      publisherList.value = [];
    }

    if (adminData) {
      adminData = handleData(adminData);
      adminList.value = [adminData];
    } else {
      adminList.value = [];
    }
  }
  dataList.value = activeKey.value === 'seller' ? sellerList.value : activeKey.value === 'publisher' ? publisherList.value : adminList.value;

  spinning.value = false;
}

const setShowModal = (status = true, reload = false) => {
  if (reload) {
    getMenus();
    menuInfo.value = {};
  }

  showEditModal.value = status;
}

// 添加子菜单
const addSubMenu = data => {
  const sortOrder = data.children?.length ? data.children[data.children.length - 1].sortOrder + 1 : 1;

  menuInfo.value = {
    parentId: data.id,
    subSortOrder: sortOrder
  };
  setShowModal(true);
}

// 设置编辑信息
const setInfoData = (data) => {
  menuInfo.value = data;
  setShowModal(true);
}

// 排序
const onSort = async (menuId1, menuId2) => {
  spinning.value = true;
  const paramsData = { menuId1, menuId2 }
  const res = await menuApi.sortMenus(paramsData);

  if (res === null) {
    getMenus();
  }

  spinning.value = false;
}

const changeMenusStatus = async (status, id) => {
  spinning.value = true;
  const paramsData = {
    hidden: !status,
    id
  }
  const res = await menuApi.changeMenusStatus(paramsData);

  if (res === null) {
    getMenus();
  }

  spinning.value = false;
}

const deleteMenus = async id => {
  spinning.value = true;
  const res = await menuApi.deleteMenus({ id });
  if (res === null) {
    getMenus();
  }
  spinning.value = false;
}

const addMenus = async paramsData => {
  spinning.value = true;
  const res = await menuApi.addMenus(paramsData);
  if (res) {
    setShowModal(false, true);
  }
  spinning.value = false;
}

// 保存编辑菜单
const changeMenu = async paramsData => {
  spinning.value = true;
  const res = await menuApi.changeMenus(paramsData);
  if (res === null) {
    setShowModal(false, true);
    getMenus();
  }
  spinning.value = false;
}

const setDataList = () => {
  dataList.value = activeKey.value === 'seller' ? sellerList.value : activeKey.value === 'publisher' ? publisherList.value : adminList.value;
}

// 使用自定义hook计算表格滚动高度
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.menu-list-wrapper',
  bottomSpace: 155,
  minHeight: 200,
  maxHeight: 800,
  defaultHeight: 350
});

onMounted(() => {
  getMenus();
})

</script>

<style lang="less" scoped>
.payments {
  padding: 0 16px;

  .content {
    overflow: hidden;
    border-radius: 12px;
    background-color: var(--color-white);
    box-shadow: var(--section-box-shadow-6);

    .tabs {
      padding: 0 16px 16px;

      :deep(.ant-tabs-nav) {
        height: 56px;
      }
    }
  }
}

.sort-btn {
  white-space: nowrap;
  button {
    margin-right: 8px;
  }
}

.actions-btn {
  white-space: nowrap;
  button {
    margin-right: 8px;

    &:last-child {
      color: var(--red-text);
    }
  }
}
</style>